import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

function diffDays(date) {
  if (date != null) {
    let now = new Date() // Data de hoje

    // data passada por parametro
    let dataSplit = date.split('-')
    let day = dataSplit[2]
    let month = dataSplit[1]
    let year = dataSplit[0]
    let date1 = new Date(year, month - 1, day)

    let timeDiff = Math.abs(now.getTime() - date1.getTime())
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    return parseInt(diffDays)
  }
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    let diff = diffDays(item.dt_dados)
    if (diff > 8 || item.dt_dados == null) {
      return true
    }
    return false
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    let diff = diffDays(item.dt_dados)
    if (diff > 8 || item.dt_dados == null) {
      return false
    }
    return true
  })
  return filtro
}
export function generatePdf(cadastros) {
  let title_pdf = 'Envio APP ACS PEC'
  let titlePdfSave = utils.methods.titlePdf('Envio APP ACS PEC')
  let description_pdf = 'Última visita do ACS encontrada no PEC'
  let headers_pdf = [
    'PROFISSIONAL ACS',
    'UNIDADE DE SAÚDE',
    'ÚLTIMA VISITA',
    'FICHAS VISITA',
    'MÉDIA EQUIPE',
    'MÉDIA MUNICIPAL',
    'SISTEMA',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_profissional = cadastros[i].no_profissional
    obj.no_unidade_saude = cadastros[i].no_unidade_saude
    if (
      cadastros[i].dt_dados !== null &&
      cadastros[i].dt_dados !== undefined &&
      cadastros[i].dt_dados !== ''
    ) {
      obj.dt_dados = utils.methods.formatDate(cadastros[i].dt_dados)
    } else {
      obj.dt_dados = '+30 dias'
    }
    obj.fichas_visita = cadastros[i].fichas
    obj.media_equipe = cadastros[i].media_visitas_ine
    obj.media_municipal = cadastros[i].media_visitas_mun
    obj.sistema = cadastros[i].sistema
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      // Data atual
      verticalPosition += 6
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(12)
      doc.text(`Data: ${dataAtual}`, 15, verticalPosition, null, null)

      verticalPosition += 6

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  'Profissional acs': 'no_profissional',
  'Unidade de saúde': 'no_unidade_saude',
  'Última visita': {
    field: 'dt_dados',
    callback: (value) => {
      if (value !== null && value !== undefined && value !== '') {
        return utils.methods.formatDate(value)
      }
      return '>30 dias'
    },
  },
  'Fichas visita': 'fichas',
  'Média equipe': 'media_visitas_ine',
  'Média Municipal': 'media_visitas_mun',
  Sistema: 'sistema',
}
